@if (enableNewSkeletonUI()) {
    <div class="bg-home-skeleton sk-casino-container bg-dark-skeleton">
        <div class="sk-banner">
            <div class="sk-title"></div>
            <div class="sk-title"></div>
            <div class="sk-title"></div>
        </div>
    </div>
} @else {
    <div class="bg-home-skeleton sk-casino-container">
        <div class="sk-banner"></div>
    </div>
}
